<template>
	<article class="order-page">
		<!-- 		<header class="page_title">
			<hgroup :class="logoImg ? 'index_title' : 'child_page_title'">
				<h1 v-if="logoImg"><img src="../../assets/logo.png" alt="候机楼logo" width="124" height="124" /></h1>
				<h3>{{ titleText }}</h3>
			</hgroup>
		</header> -->

		<section class="order-container">
			<header>
				<div class="thumb-wrap"><img src="//www.callmefix.net/api/Event/getImage?type=1&name=30" alt="" /></div>
				<div class="text-description">
					<div>
						<h3>{{ submitInfo.goodsName }}</h3>
						<span class="gray-text">
							<p>联系人:{{ submitInfo.linkMan }}</p>
							<p>联系电话:{{ submitInfo.phone }}</p>
							<p>用车时间:{{ submitInfo.bookDate }} {{ submitInfo.bookTime }}</p>
							<p>接送地址:{{ submitInfo.address }}上车</p>
							<p>客户备注:{{ submitInfo.remarks }}</p>
						</span>

						<p class="red-text">
							<i class="iconfont icon-renminbi"></i>
							<span>{{ submitInfo.goodsPrice }}</span>
						</p>
					</div>
					<span>x{{ submitInfo.goodsCount }}</span>
				</div>
			</header>

			<div class="show-price">
				<p>
					<span>商品金额</span>
					<span>
						<i class="iconfont icon-renminbi"></i>
						{{ submitInfo.goodsPrice }}
					</span>
				</p>

				<p>
					<span>合计:</span>
					<span class="red-text">
						<i class="iconfont icon-renminbi"></i>
						{{ submitInfo.goodsPrice }}
					</span>
				</p>
			</div>

			<p class="gray-text">消费提醒:货款直接给商家,由商家承担全部售后服务</p>
		</section>

		<!-- <index-footer :btnText="footBtnText" :isHavePrice="true" :goodsPrice="submitInfo.goodsPrice" @createOrder="createOrder"></index-footer> -->
		<!-- 	<footer class="page-footer">
			
			<div class="terms" @click="checkIsAgree">
				<i :class="isAgree ? 'iconfont icon-yigouxuan' : 'iconfont icon-weigouxuan'"></i>
				<p>
					<span>阅读并同意</span>
					<span class="primaryColor-text" @click.stop="showWarningTips">《服务细则》</span>
				</p>
			</div>

			<p class="goods-price">
				<span>合计:</span>
				<span class="red-text">
					<i class="iconfont icon-renminbi"></i>
					{{ submitInfo.goodsPrice }}
				</span>
			</p>
			<button @click="createOrder" :disabled="!isAgree">提交预订</button>
		</footer> -->
		<footer>
			<div class="terms" @click="checkIsAgree">
				<i :class="isAgree ? 'iconfont icon-yigouxuan' : 'iconfont icon-weigouxuan'"></i>
				<p>
					<span>我已阅读并同意</span>
					<span class="primaryColor-text" @click.stop="showWarningTips">《红旗专车秒杀价格细则》</span>
				</p>
			</div>

			<div class="price_payment">
				<p class="price_text">
					总价 :
					<span class="red-text">&yen;{{ submitInfo.goodsPrice }}</span>
					<!-- <i class="iconfont icon-xiala iconreversal"></i> -->
				</p>
				<button :class="!isAgree ? 'payment_btn' : 'payment_btn usable'" :disabled="!isAgree" @click="createOrder">提交订单</button>
			</div>
		</footer>

		<!--服务协议弹出层 Start  -->
		<transition name="tanchu" mode="out-in">
			<article v-show="showMask" class="mask_wrap" @click.self="showWarningTips">
				<!-- <section :class="['mask_container_wrap',showMask?'scale_up':'']"> -->
				<transition name="scasle_up" mode="out-in">
					<section v-if="showMask" :class="['mask_container_wrap']">
						<div class="mask_article_wrap">
							<h3 class="article_title red_color">红旗专车秒杀价格细则</h3>
							<!-- <p class="red-text">*当天12:30以前的班车接送，在乘车前一天下午17:00左右通知实际接送乘车时间</p>
							<p class="red-text">*当天12:30以后的班车接送，在乘车当天早上10:00左右通知实际接送乘车时间</p> -->

							<p class="p_title">产品说明：</p>
							<p>1、此产品为红旗专车，一价全包，已包含路桥费，车辆费用</p>
							<p>2、此产品价格仅为城区内出发/到达，各镇区出发/到达按加收说明标准收费，无加收镇区按原产品价格收取</p>
							<p>3、需按我司指定路线行驶，不接受中途经停、绕路、临时改变路线；</p>
							<p>4、城区内限2个接送地址，镇区反向接送按加收说明加收费用；</p>
							<p>5、购买前应自行考虑时间是否充足，车辆在正常行驶或遇塞车、天气原因等及不可抗力的情况下，导致误机等所产生的费用与我司无关；</p>

							<p class="p_title">等候说明</p>
							<p>1、接机：航班延误时间在(5:00-22:00内)免费等候；航班落地后，司机免费等候，若由于航班延误的原因，航班落地时间超出22:00，将收取50元/程夜间服务费，若经旅客确认司机可到达停车场后，因旅客原因所产生停车费用旅客自行承担；</p>
							<p>2、送机/送火车：免费等15分钟；</p>
							<p>3、接火车：免费等60分钟；超时等候费：超时后如继续用车，需要根据司机额外等候时长收费，1元/分钟；</p>

							<p class="p_title">加收说明：</p>
							<p>1、往广州、深圳方向：南朗镇、板芙镇、五桂山镇加收50元/程，三乡镇、神湾镇、坦洲镇加收100元/程。</p>
							<p>2、往珠海方向：古镇镇、小揽镇、南头镇、黄圃镇、东凤镇、三角镇、阜沙镇、民众镇加收50元/程。</p>

							<p class="p_title">取消说明：</p>
							<p>1、距离出发时间提前48小时以上免费取消；</p>
							<p>2、距离出发时间提前24小时-48小时取消，收取10%手续费；</p>
							<p>3、距离出发时间提前24小时-2小时取消，收取20%手续费；</p>
							<p>4、距离出发时间2小时-30分钟取消，收取50%手续费；</p>
							<p>5、距离出发时间30分钟内不得取消；</p>

							<p class="p_title">车型说明：</p>
							<p>1、车辆安排遵照同级或升级车辆安排准则；</p>
							<p>2、车型承载人数为5人，包含司机1人，实际承载旅客为4人（儿童、婴儿计入乘车人数），由于您自身选择车型不符而影响您的用车，该损失由您自行承担；</p>
							<p>3、行李大于3件时，需和客服人员核实行李尺寸；</p>
						</div>
					</section>
				</transition>
			</article>
		</transition>
		<!--服务协议弹出层 End -->
	</article>
</template>

<script>
import scopeApi from '../request/scopeApi';
import orderApi from '../request/orderApi';
import frequencyApi from '../request/frequencyApi';
import paymentApi from '../request/paymentApi';
export default {
	name: 'CreateSpecialCarOrder',
	data() {
		return {
			remarks: '',
			submitInfo: {
				linkMan: '',
				phone: '',
				address: '',
				bookDate: '',
				bookTime: '',
				goodsCount: 0,
				goodsName: '',
				goodsPrice: 0,
				remarks: '',
				flightNumber: '',
				getOff: ''
			},
			getOff: '',
			orderInfo: null,
			location: '',
			frequencyId: '',
			frequencyModel: '',
			showMask: false,
			isAgree: false
		};
	},
	activated() {
		this.getRouterData();
		this.orderInfo = null;
		wx.getLocation({
			type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
			success: res => {
				let latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
				let longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
				let speed = res.speed; // 速度，以米/每秒计
				let accuracy = res.accuracy; // 位置精度
				that.location = longitude + ',' + latitude;
			}
		});
	},
	methods: {
		getRouterData() {
			if (this.$route.params.submitInfo) {
				console.log('CreateSpecialCarOrder=>submitInfo=>', this.submitInfo);
				this.submitInfo = this.$route.params.submitInfo;
				this.frequencyId = this.$route.params.frequencyId;
				this.remarks = this.submitInfo.remarks;
				this.getOff = this.submitInfo.getOff;
			}
		},
		createOrder() {
			if (this.orderInfo && this.orderInfo.ID) {
				this.payRequests();
			} else {
				orderApi
					.createSpecialCarOrder(
						this.$store.state.user.OpenId,
						this.submitInfo.goodsName,
						'',
						'广东省',
						'中山市',
						this.submitInfo.address,
						this.submitInfo.linkMan,
						this.submitInfo.phone,
						0,
						this.submitInfo.goodsCount,
						this.submitInfo.flightNumber,
						this.submitInfo.bookDate + ' ' + this.submitInfo.bookTime,
						this.submitInfo.goodsPrice,
						1,
						this.remarks,
						this.location,
						this.getOff,
						this.frequencyId
					)
					.then(sucRes => {
						if (sucRes.success) {
							this.$Message.success(sucRes.message);
							this.orderInfo = sucRes.data;
							this.payRequests();
						} else {
							alert(sucRes.message);
						}
					});
			}
		},
		payRequests() {
			var that = this;
			wx.miniProgram.getEnv(function(res) {
				if (res.miniprogram) {
					var url = `../webpayprocess/webpayprocess?ordertype=0&id=${that.orderInfo.ID}&businessid=2`;
					wx.miniProgram.navigateTo({
						url: url
					});
				} else {
					paymentApi.getWeChatPayParams(that.$store.state.user.OpenId, that.orderInfo.ID, 2, 0).then(sucRes => {
						if (sucRes.success) {
							wx.chooseWXPay({
								timestamp: sucRes.data.timeStamp,
								nonceStr: sucRes.data.nonceStr,
								package: sucRes.data.package,
								signType: sucRes.data.signType,
								paySign: sucRes.data.paySign,
								success: function(resPay) {
									console.log(resPay);
									that.$Message.success(resPay + '支付成功！');
									window.host.href = 'https://www.callmefix.net/wechat/orderlst';
								}
							});
						}
					});
				}
			});
		},
		showWarningTips() {
			this.showMask = !this.showMask;
		},
		checkIsAgree() {
			this.isAgree = !this.isAgree;
		}
	}
};
</script>

<style lang="less" scoped>
@import '../style/public';
.terms {
	background-color: rgba(0, 0, 0, 0.8);
	color: #fff;
	font-size: 0.35rem;
	line-height: 8vh;
	.flex_wrap(initial, center);
}
.terms > p {
	font-size: 0.4rem;
}
.terms > .iconfont {
	width: 15%;
	align-self: stretch;
	text-align: center;
	font-size: 0.5rem;
	padding-top: 2px;
	margin: 0;
}
.terms > .iconfont.icon-yigouxuan {
	color: #69cbff;
}

.price_payment {
	border-top: 1px solid #888;
	.flex_wrap;
}
.price_payment > .price_text,
.price_payment > .payment_btn {
	flex: 0 0 50%;
}
.price_text,
.payment_btn {
	line-height: 1.2rem;
	text-align: center;
	font-size: 0.45rem;
}
.price_text > span {
	font-weight: 600;
	transition: all 0.3s;
}
.payment_btn {
	border: none;
	color: #888;
	background-color: #ddd;
}

.usable {
	background-color: #e22222;
	color: #fff;
}
.payment_btn.usable:active {
	background-color: #ba1b1b;
	color: #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/CreateSpecialCarOrder.vue